import { Settings, Info, Trash2, X } from "lucide-react";
import "../styles/TileAppPage.css";

export default function TilePageLayout({
  title = "Page",
  subtitle = "",
  IconComponent = null,
  children,

  showSettings = true,
  showInfo = true,
  showUninstall = false,
  showClose = true,
  showHeader = true,

  onSettings = () => console.log("Settings clicked"),
  onInfo = () => console.log("Info clicked"),
  onUninstall = () => console.log("Uninstall clicked"),
  onClose = () => console.log("Close clicked"),
}) {
  return (
    <div className="tile-page">

      {/* =========================
          TOP BAR
      ========================= */}
      {showHeader ? (
        <div className="tile-top">

          <div className="tile-heading">
            {IconComponent ? (
              <span className="tile-app-icon" aria-hidden="true">
                <IconComponent size={22} />
              </span>
            ) : null}
            <div className="tile-title-stack">
              <div className="tile-title">
                {title}
              </div>
              {subtitle ? <div className="tile-subtitle">{subtitle}</div> : null}
            </div>
          </div>

          <div className="tile-actions">
            {showUninstall && (
              <button
                className="tile-icon-btn danger uninstall-btn"
                onClick={() => {
                  if (window.confirm("Uninstall this app?")) {
                    onUninstall();
                  }
                }}
              >
                <Trash2 size={18} />
                <span>Uninstall</span>
              </button>
            )}

            {showSettings && (
              <button
                className="tile-icon-btn"
                onClick={onSettings}
              >
                <Settings size={20} />
              </button>
            )}

            {showInfo && (
              <button
                className="tile-icon-btn"
                onClick={onInfo}
              >
                <Info size={20} />
              </button>
            )}

            {showClose && (
              <button
                className="tile-icon-btn close-btn"
                onClick={onClose}
                aria-label="Close tile app"
                title="Close"
              >
                <X size={20} />
              </button>
            )}

          </div>

        </div>
      ) : null}

      {/* =========================
          BODY
      ========================= */}
      <div className="tile-body">
        <div className="tile-content">
          {children}
        </div>
      </div>

    </div>
  );
}
